export const SCREEN_RULE = 'showtime.comscore.studio.advancedSalesPerspective';
